import { useState } from 'react';

import { useGetSurchargesMaintenance } from 'queries';
import { useTranslation } from 'react-i18next';

import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import WithInnerLayout from '../../../../shared/CRUD/components/InnerPage/WithInnerLayout';
import CreateEditSurchargeMaintenance from './components/CreateEditSurchargesMaintenance';
import EditSurchargesMaintenance from './components/innerView/EditSurchargesMaintenance';

import useColumnDefinitions from './hooks/useColumnDefinitions';
import { useDeleteSurchargesMaintenance } from './hooks/useDeleteSurchargesMaintenance';

const SurchargesMaintenance = ({ isInnerLayoutOpen, setIsInnerLayoutOpen }) => {
  const { t } = useTranslation();
  const { data: rows, isFetching, refetch } = useGetSurchargesMaintenance();
  const columnDefinitions = useColumnDefinitions();
  const handleDeleteClick = useDeleteSurchargesMaintenance();
  const [rowData, setRowData] = useState(undefined);

  const toggleInnerLayout = () => {
    setIsInnerLayoutOpen(!isInnerLayoutOpen);
  };

  const onViewCLick = (rowData) => {
    setRowData(rowData);
    setIsInnerLayoutOpen(true);
  };

  if (isInnerLayoutOpen && rowData) {
    return (
      <EditSurchargesMaintenance
        rowData={rowData}
        toggleInnerLayout={toggleInnerLayout}
        refreshList={refetch}
        rows={rows}
      />
    );
  }

  return (
    <TableCRUDLayout
      FormComponent={CreateEditSurchargeMaintenance}
      loading={isFetching}
      columns={columnDefinitions}
      rows={rows}
      getRowId={(row) => row.surchargeId}
      editable={false}
      onDeleteClick={handleDeleteClick}
      confirmationTitle={t('surchargesMaintenance.delete.title')}
      confirmationBody={t('surchargesMaintenance.delete.body')}
      onViewClick={(rowId, rowData) => onViewCLick(rowData)}
    />
  );
};

export default WithInnerLayout(SurchargesMaintenance);
